// extracted by mini-css-extract-plugin
module.exports = {"InfoBox":"InfoBox-module__InfoBox___3v49Q","infoFlag":"InfoBox-module__infoFlag___LLpQf","flag":"InfoBox-module__flag___30VMB","label":"InfoBox-module__label___2yqDQ"};